export default __webpack_public_path__ + "static/media/javascript.bacc3387.svg";